import { render, staticRenderFns } from "./SalesReturn.vue?vue&type=template&id=9fef99c2&"
import script from "./SalesReturn.vue?vue&type=script&lang=js&"
export * from "./SalesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesReturn.vue"
export default component.exports